import { StyleSheet, Platform } from 'react-native';
import FontFamily from '../../../../constants/fonts';

export const styles = StyleSheet.create({
  sparcKpiListSection: {
    backgroundColor: '#FFFFFF',
    borderRadius: 8,
    marginTop: 20,
    // marginBottom: 20,
    paddingHorizontal: 20,
    paddingVertical: 20,
    overflow: 'visible',
  },
  sparcKpiListMainHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 16,
  },
  sparcKpiListMainTitle: {
    fontSize: 24,
    fontWeight: '700',
    color: '#1C1C1C',
    fontFamily: FontFamily.bold,
  },
  printButtonContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
    paddingVertical: 6,
    paddingHorizontal: 12,
    borderWidth: 1,
    borderColor: '#D8E7FB',
    borderRadius: 4,
  },
  printButtonText: {
    fontSize: 14,
    fontWeight: '400',
    color: '#004895',
    fontFamily: FontFamily.regular,
  },
  sparcBoardContainer: {
    backgroundColor: '#F5F9FF',
    borderRadius: 12,
    padding: 16,
    overflow: 'visible',
  },
  sparcBoardTitle: {
    fontSize: 16,
    fontWeight: '700',
    color: '#1C1C1C',
    fontFamily: FontFamily.bold,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
    backgroundColor: '#F7FAFC',
    paddingRight: 12,
  },
  dividerWithHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    marginVertical: 16,
    position: 'relative',
    zIndex: 1000,
  },
  dividerLineCenter: {
    flex: 1,
    height: 1,
    backgroundColor: '#E0E0E0',
    marginHorizontal: 0,
  },
  dropdownContainer: {
    position: 'relative',
    backgroundColor: '#F7FAFC',
    paddingLeft: 12,
    zIndex: 1000,
  },
  dropdown: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 6,
    paddingHorizontal: 0,
    backgroundColor: '#FFFFFF',
    borderRadius: 4,
    borderWidth: 1,
    borderColor: '#C6DCFB',
    minWidth: 100,
  },
  dropdownTextContainer: {
    width: '65%',
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 8,
  },
  dropdownText: {
    fontSize: 14,
    fontWeight: '400',
    color: '#1C1C1C',
    fontFamily: FontFamily.regular,
  },
  dropdownDivider: {
    width: 1,
    height: 20,
    backgroundColor: '#C6DCFB',
  },
  dropdownIconContainer: {
    width: '35%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  dropdownMenu: {
    position: 'absolute',
    top: 40,
    right: 0,
    backgroundColor: '#FFFFFF',
    borderRadius: 4,
    borderWidth: 1,
    borderColor: '#E0E0E0',
    minWidth: 100,
    zIndex: 10000,
    elevation: 10,
    ...Platform.select({
      ios: {
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.1,
        shadowRadius: 4,
      },
      android: {
        elevation: 4,
      },
      web: {
        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
      },
    }),
  },
  dropdownMenuItem: {
    paddingVertical: 8,
    paddingHorizontal: 12,
  },
  dropdownMenuItemText: {
    fontSize: 14,
    fontWeight: '400',
    color: '#616161',
    fontFamily: FontFamily.regular,
  },
  dropdownMenuItemTextActive: {
    color: '#005CBC',
    fontWeight: '600',
  },
  sparcSelectedSection: {
    backgroundColor: '#FFFFFF',
    borderRadius: 8,
    padding: 20,
    minHeight: 200,
    marginBottom: 16,
  },
  emptyStateContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: 26,
  },
  emptyStateTitle: {
    fontSize: 18,
    fontWeight: '700',
    color: '#3A3A3A',
    fontFamily: FontFamily.bold,
    marginTop: 16,
    marginBottom: 8,
  },
  emptyStateDescription: {
    fontSize: 14,
    fontWeight: '400',
    color: '#616161',
    fontFamily: FontFamily.regular,
    textAlign: 'center',
    paddingTop: 8,
  },
  sparcCardsRow: {
    flexDirection: 'row',
    gap: 12,
    marginBottom: 16,
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
  },
  sparcGroupContainer: {
    marginTop: 8,
  },
  sparcGroupHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
    marginBottom: 10,
  },
  sparcGroupDot: {
    width: 10,
    height: 10,
    borderRadius: 5,
  },
  sparcGroupTitle: {
    fontSize: 14,
    fontFamily: FontFamily.bold,
    color: '#2D2F33',
    letterSpacing: 0.3,
  },
  sparcGroupBadge: {
    fontSize: 12,
    fontFamily: FontFamily.medium,
    color: '#5F6670',
    marginLeft: 4,
  },
  sparcCardEqualWrapper: {
    // Removed - sizing now set inline via width property
  },
  sparcSelectedCardsRow: {
    flexDirection: 'row',
    gap: 12,
    marginBottom: 16,
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
  },
  sparcSelectedCardWrapper: {
    // Removed - sizing now set inline via width property
  },
  loadingText: {
    fontSize: 14,
    fontWeight: '400',
    color: '#616161',
    fontFamily: FontFamily.regular,
    textAlign: 'center',
    paddingVertical: 20,
  },
  emptyText: {
    fontSize: 14,
    fontWeight: '400',
    color: '#616161',
    fontFamily: FontFamily.regular,
    textAlign: 'center',
    paddingVertical: 20,
  },
  // Skeleton styles
  skeletonCard: {
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    borderWidth: 1,
    borderColor: '#E0E7FF',
    padding: 16,
    minHeight: 280,
    ...Platform.select({
      ios: {
        shadowColor: 'rgba(99, 102, 241, 0.1)',
        shadowOffset: { width: 0, height: 4 },
        shadowOpacity: 1,
        shadowRadius: 8,
      },
      android: {
        elevation: 4,
      },
      web: {
        boxShadow: '0px 4px 8px rgba(99, 102, 241, 0.1)',
      },
    }),
  },
  skeletonHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 10,
  },
  skeletonHeaderLeft: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
  },
  skeletonBadge: {
    width: 24,
    height: 24,
    borderRadius: 4,
    backgroundColor: '#E0E0E0',
  },
  skeletonTitle: {
    width: 120,
    height: 16,
    borderRadius: 4,
    backgroundColor: '#E0E0E0',
  },
  skeletonFavorite: {
    width: 24,
    height: 24,
    borderRadius: 4,
    backgroundColor: '#E0E0E0',
  },
  skeletonMetrics: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    borderRadius: 16,
    borderWidth: 1,
    borderColor: '#E3F2FD',
    paddingVertical: 12,
    paddingHorizontal: 2,
    marginBottom: 10,
  },
  skeletonMetricItem: {
    flex: 1,
    alignItems: 'center',
  },
  skeletonMetricLabel: {
    width: 40,
    height: 12,
    borderRadius: 4,
    backgroundColor: '#E0E0E0',
    marginBottom: 8,
  },
  skeletonMetricValue: {
    width: 30,
    height: 16,
    borderRadius: 4,
    backgroundColor: '#E0E0E0',
  },
  skeletonChart: {
    flexDirection: 'row',
    gap: 8,
    minHeight: 100,
  },
  skeletonYAxis: {
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    marginBottom: 22,
    marginTop: -6,
  },
  skeletonYLabel: {
    width: 20,
    height: 12,
    borderRadius: 4,
    backgroundColor: '#E0E0E0',
  },
  skeletonBars: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'flex-end',
    borderBottomWidth: 1,
    borderBottomColor: '#E0E0E0',
    paddingBottom: 8,
    gap: 4,
    height: 72,
  },
  skeletonBar: {
    flex: 1,
    backgroundColor: '#E0E0E0',
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    minWidth: 8,
  },
});
